var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 14,
    viewBox: "0 0 3 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M1.8543 14H0.556291C0.445033 14 0.370861 13.9258 0.370861 13.7775V4.07947C0.370861 3.93113 0.42649 3.85695 0.61192 3.85695H1.83576C2.02119 3.85695 2.07682 3.91258 2.07682 4.07947V13.7775C2.07682 13.9258 2.02119 14 1.8543 14ZM1.22384 2.46623C0.537748 2.46623 0 1.90993 0 1.22384C0 0.537749 0.537748 0 1.22384 0C1.89139 0 2.44768 0.537749 2.44768 1.22384C2.44768 1.90993 1.89139 2.46623 1.22384 2.46623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.544e7fb52071be04c25bd9f6244a9574.svg";
export { ForwardRef as ReactComponent };